import { UrlConstants } from "../url.constants";
export class ApiCommentsConstants {
    // TODO: JP to clean code - Speak to Matthew
    static URL = UrlConstants.API_V2 + "RequestComments";
    static URL_COMMENT = UrlConstants.API_V2 + "Comment";
    static FUNCTION_GET_REQUEST_COMMENTS = "GetRequestComment";
    static FUNCTION_UPDATE_REQUEST_COMMENT_STATUS = "UpdateRequestCommentStatus";
    static FUNCTION_UPLOAD_ATTACHMENT = "UploadAttachment";
    static FUNCTION_GET_PUBLIC_BU_LOOKUPS = "GetPublicBusinessUnits";
    static FUNCTION_GET_PUBLIC_REQUEST_COMMENT = "GetPublicRequestComments";
    static FUNCTION_SAVE_PUBLIC_COMMENT = "SavePublicComment";
}
